import Loader from "./loading.json"

export default {
    Loader
}